module.exports = __webpack_public_path__ + "img/313131_BBBBBB_878787_A3A4A4-256px.86343a07.png";